import classes from '../main.module.css'
import { useState, useEffect } from 'react'

const Navbar = ({ onContactClick }) => {

    const [isActive, setIsActive] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const isScrolled = window.scrollY > 50;
            if (isScrolled !== scrolled) {
                setScrolled(isScrolled);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [scrolled]);

    const toggleActiveClass = () => {
        setIsActive(!isActive);
    }

    const removeActive = () => {
        setIsActive(false)
    }

    const handleContactClick = (e) => {
        e.preventDefault();
        removeActive();
        onContactClick();
    }

    return (
        <header className={`${classes.Header} ${scrolled ? classes.HeaderScrolled : ''}`}>
            <nav className={`${classes.Navbar} ${scrolled ? classes.NavbarScrolled : ''}`}>
                <img src={`/images/feline_logo.svg`} className={classes.Logo} alt="feline" />
                <ul className={`${classes.NavMenu} ${isActive ? classes.active : ''}`}>
                    <li onClick={removeActive}>
                        <a href='#home' className={classes.NavHeadings}>Home</a>
                    </li>
                    <li onClick={removeActive}>
                        <a href='#about' className={classes.NavHeadings}>About Us</a>
                    </li>
                    <li onClick={removeActive}>
                        <a href='#services' className={classes.NavHeadings}>Our Services</a>
                    </li>
                    <li onClick={removeActive}>
                        <a href='#case-studies' className={classes.NavHeadings}>Case Studies</a>
                    </li>
                    <li onClick={removeActive}>
                        <a href='#team' className={classes.NavHeadings}>Our Team</a>
                    </li>
                    <li>
                        <button onClick={handleContactClick} className={classes.NavHeadings}>Contact Us</button>
                    </li>
                </ul>
                <div className={`${classes.HamBurger} ${isActive ? classes.active : ''}`}
                    onClick={toggleActiveClass}>
                    <span className={classes.Bar}></span>
                    <span className={classes.Bar}></span>
                    <span className={classes.Bar}></span>
                </div>
            </nav>
        </header>
    );

}

export default Navbar